// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderLayout_header__3x7aw","main-image":"HeaderLayout_main-image__1QZvh"};